import { render, staticRenderFns } from "./AddPlaceOfLoading.vue?vue&type=template&id=19ec5c3a&scoped=true"
import script from "./AddPlaceOfLoading.vue?vue&type=script&lang=js"
export * from "./AddPlaceOfLoading.vue?vue&type=script&lang=js"
import style0 from "./AddPlaceOfLoading.vue?vue&type=style&index=0&id=19ec5c3a&prod&scoped=true&lang=css"
import style1 from "./AddPlaceOfLoading.vue?vue&type=style&index=1&id=19ec5c3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec5c3a",
  null
  
)

export default component.exports